<template>
  <div>
    <BlTextAv variation="body-16" tag="h2" class="p-16" weight="bold">{{ title }}</BlTextAv>
    <div 
      class="section-content ph-16 pb-8 sanitize-text" 
      :class="{'is-expanded': isExpanded, 'is-expandable': isExpandable}"
      :style="cssHeightVar"
    >
      <BlTextAv ref="content" v-html="content"></BlTextAv>
    </div>
    <BlButtonAv v-if="isExpandable" variation="naked" size="small" class="pl-16" @click="toggleExpand">{{ expandTriggerText }}</BlButtonAv>
  </div>
</template>

<script>
import {BlButtonAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaDetailExpandableSection',
  components: {
    BlButtonAv,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 86
    }
  },
  data() {
    return {
      isExpanded: false,
      isExpandable: false,
    };
  },
  computed: {
    expandTriggerText() {
      return this.isExpanded ? 'Sembunyikan' : 'Lihat selengkapnya';
    },
    cssHeightVar() {
      return {
        '--height': this.height + 'px'
      }
    }
  },
  mounted() {
    this.isExpandable = this.$refs.content?.$el?.clientHeight > this.height;
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-content {
  height: auto;
  overflow: hidden;
  &.is-expandable {
    height: var(--height);
  }
  &.is-expanded {
    height: 100%;
  }
}
</style>
